module.exports = __webpack_public_path__ + "static/media/Mouth_1.794426fe.jpg";